export default {
    methods: {
        formatDate(date, params = { dateStyle: 'short', timeStyle: 'medium' }) {
            if (!date) return;

            return new Intl.DateTimeFormat(['en-GB'], {
                dateStyle: params.dateStyle,
                timeStyle: params.timeStyle,
                dateTimeSeparator: '.',
            })
                .format(new Date(date))
                .replaceAll('/', '.')
                .replace(',', ' ');
        },
    },
};
